// libraries.
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

// slices.
import { apiBudgetRoute } from "../apiSlices";

// interfaces.
import { ModelError } from "../interfaces/interfaces";
import {
  RawTool,
  RawToolsApiResponse,
} from "./interfaces/rawRules.interfaces";

// ─── Endpoint ─────────────────────────────────────────────────────────────────

export const rulesToolsEndpoints = apiBudgetRoute.injectEndpoints({
  endpoints: (builder) => ({
    getRulesTools: builder.query<RawTool[], void>({
      query: () => ({
        url: "/rules/tools",
        method: "GET",
      }),
      transformErrorResponse: (error: FetchBaseQueryError) => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: "getRulesTools",
        };
        return modelError;
      },
      transformResponse: (raw: RawToolsApiResponse) => raw.data.tools,
    }),
  }),
});

export const { useGetRulesToolsQuery } = rulesToolsEndpoints;
